<template>
  <div class="mx-2 mb-2">
    <b-row>
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <div class="d-flex align-items-center entity-filter">
            <span>Show</span>
            <div class="custom-dropdown-dynamic pagin px-1">
              <v-select
                v-model="pagination.perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pagination.perPageOptions"
                :clearable="false"
                @input="onSelectEntities"
                class="entity-filter"
              />
            </div>
            <span class="mr-1">Entities</span>
          </div>
      </b-col>
      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.totalRows"
          :per-page="pagination.perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0 dynamic-table-pagination"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { BRow, BCol, BPagination } from 'bootstrap-vue';
  export default {
    components: {
      BRow,
      BCol,
      BPagination,
    },
    props: {
      paginationInfo: String,
      pagination: Object,
      isLoading: Boolean,
      onSelectEntities: Function
    },
  };
</script>

<style></style>
